import React, { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import Nav from "../Nav";
import Navbar from "../Navbar";
import { useNavigate } from "react-router-dom";
import Consent from "./Consent";

export default function Professional() {
  const navigate = useNavigate();

  // Define a function to reset the form fields
  const handleReset = () => {
    setOrganization("");
    setOrganizationError("");
    setPosition("");
    setError("");
    setType("");
    setTypeError("");
  };

  // State to handle incorrect Name of Organization
  const [organization, setOrganization] = useState("");
  const [organizationError, setOrganizationError] = useState("");

  // If Name of the organization is not a string
  const handleOrganizationChange = (event) => {
    const value = event.target.value;
    setOrganization(value);
    if (isNaN(value)) {
      setOrganizationError("");
    } else {
      setOrganizationError("Please enter a valid Organization");
    }
  };

  //.....................................................................................................
  const [position, setPosition] = useState("");
  const [error, setError] = useState("");

  const handleInputChange = (event) => {
    setPosition(event.target.value);
    if (position.trim().length !== 0) {
      setError("");
    } else {
      setError("Please enter your position");
    }
  };

  //...................................................................................................

  // State to handle Type of organization is not Selected
  const [type, setType] = useState("");
  const [typeError, setTypeError] = useState("");

  // If Type Of Organization is not Selected
  const handleTypeChange = (event) => {
    const selectedType = event.target.value;
    if (selectedType === "") {
      setTypeError("Please select type of your organization");
    } else {
      setType(selectedType);
      setTypeError("");
    }
  };
  useEffect(() => {
    // Check if all necessary fields are present in local storage
    const requiredFields = ["surname", "country", "title", "role", "email"];
    const registrationData = JSON.parse(
      localStorage.getItem("registrationData")
    );

    if (
      !registrationData ||
      requiredFields.some((field) => !registrationData[field])
    ) {
      // Redirect to the registration form if data is not complete
      navigate("/profile"); // Adjust the path to your registration form
    }
  }, [navigate]);

  //......................................................................................................

  return (
    <div>
      <Nav />
      <Navbar />
      <div className="flex flex-col items-center min-h-screen pt-6 sm:justify-center sm:pt-0 bg-gray-100">
        <div>
          <a href="/">
            <h3 className="text-4xl font-bold text-indigo-900">
              Professional Details
            </h3>
          </a>
        </div>
        <div className="w-full px-6 py-4 mt-6 overflow-hidden bg-white shadow-md sm:max-w-xl md:max-w-2xl lg:max-w-3xl">
          <form>
            <div className="mt-4">
              <label
                htmlFor="organization"
                className="block font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-t-[8px]"
              >
                Name of Your Organization
                <span className="text-red-500 italic">*</span>
              </label>
              <div className="flex flex-col items-start">
                <input
                  type="text"
                  name="organization"
                  autoComplete="none"
                  autoCorrect="none"
                  placeholder="Enter Name of your Organization"
                  className="block w-full mt-1  rounded-[8px] shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 h-15 px-4 py-2 border-2 border-gray-400"
                  onChange={handleOrganizationChange}
                  value={organization}
                />
              </div>
              {organizationError && (
                <span className="text-red-500 ">{organizationError}</span>
              )}
            </div>

            <div className="mt-4">
              <label
                htmlFor="organization-type"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-t-[8px]"
              >
                Type of Your Organization
                <span className="text-red-500 italic">*</span>
              </label>
              <div className="relative inline-block w-full">
                <select
                  className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded-sm leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  onChange={handleTypeChange}
                  value={type}
                >
                  <option value="">Select...</option>
                  <option value="Ministry">Ministry</option>
                  <option value="Department">Department</option>
                  <option value="Agency">Agency</option>
                  <option value="County Goverment">County Goverment</option>
                  <option value="Academia">Academia</option>
                  <option value="Civil Society">Civil Society</option>
                  <option value="Non-Goverment Orginization">
                    Non-Goverment Organization
                  </option>
                  <option value="Internal Organization">
                    International Organization
                  </option>
                  <option value="Self Employed">Self Employed</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 mb-4">
                  <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M6.293 6.707a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
              {typeError && (
                <span className="text-red-500 italic ">{typeError}</span>
              )}
            </div>

            <div>
              <label
                htmlFor="position"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-t-[8px] mt-7"
              >
                Position<span className="text-red-500 italic">*</span>
              </label>
              <div className="flex flex-col items-start">
                <input
                  type="text"
                  name="position"
                  autoComplete="false"
                  placeholder="Position in the Organization"
                  className="block w-full mt-1  rounded-[8px] shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 h-15 px-4 py-2 border-2 border-gray-400"
                  value={position}
                  onChange={handleInputChange}
                />
              </div>
              {error && <p className="text-red-500 italic">{error}</p>}
            </div>

            <div>
              <Consent />
            </div>

            <button
              className=" text-blue-700 hover:underline"
              type="reset"
              onClick={handleReset}
            >
              Reset?
            </button>
            <div className="flex items-center mt-4">
              <button
                onClick={() => {
                  if (
                    organization === "" ||
                    position === "" ||
                    type === "" ||
                    organizationError !== "" ||
                    typeError !== ""
                  ) {
                    alert("Please fill all required fields");
                  } else {
                    navigate("/confirmation", {
                      state: {
                        organization: organization,
                        type: type,
                        position: position,
                      },
                    });
                  }
                }}
                className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-indigo-900 rounded-md hover:bg-green-500 focus:outline-none focus:bg-purple-600"
              >
                Next
              </button>
            </div>
            <div>
              {organization === "" ||
              position === "" ||
              type === "" ||
              organizationError !== "" ||
              typeError !== "" ? (
                <span className="text-red-500 italic mt-2">
                  Please fill all required fields *
                </span>
              ) : null}
            </div>
          </form>
          <div className="mt-4 text-grey-600">
            Already Registered?{" "}
            <span>
              <a
                onClick={() => navigate("/")}
                className="text-blue-700 hover:underline "
                href="/"
              >
                Home
              </a>
            </span>
          </div>
        </div>
      </div>
      <div className="mt-2">
        <Footer />
      </div>
    </div>
  );
}
